import { render, staticRenderFns } from "./WxOpenWeapp.vue?vue&type=template&id=494a165b&scoped=true"
import script from "./WxOpenWeapp.vue?vue&type=script&lang=js"
export * from "./WxOpenWeapp.vue?vue&type=script&lang=js"
import style0 from "./WxOpenWeapp.vue?vue&type=style&index=0&id=494a165b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494a165b",
  null
  
)

export default component.exports